

import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { ConstantsCatalogosIdService } from 'src/app/services/constants-catalogos-id.service';
import { AppState } from 'src/app/app.reducer';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-riesgos',
  templateUrl: './riesgos.component.html',
  styleUrls: ['./riesgos.component.css']
})
export class RiesgosComponent implements OnInit {
  breadCrumbItems = [{ label: 'Formulación planes' }, { label: 'Elementos' }, { label: 'Riesgos', active: true }];

 // public nameApp = 'Riesgos';
  public objetivo = '';
  public lineaAccion = '';
  public planAccion = '';
  public proyecto = '';
  public proceso = '';
  public nameLineaAccion: any;
  public nivelSelect!: number
  private currentUser!: any;
  private buffer!: any;
  public idSprNivelN5: number = 0;
  public idSprNivelN1: number = 0;
  private idSprAmbiente: number = 0;
  public idSprAnio: number = 0;

  //Variable que almacena el plan Años seleccionado
  public planAnioSeleccionadoRedux: any = null;


  constructor(
    public store: Store<AppState>
  ) {
    this.openObjetivos();
    this.openLineasAccion();
    this.openPlanesAccion();
    this.openProyectos();
    this.idSprNivelN5 = ConstantsCatalogosIdService.ID_COMUNES_NIVEL_5; //validacion (de nivel n5)
    this.idSprNivelN1 = ConstantsCatalogosIdService.ID_COMUNES_NIVEL_1; //validacion (de nivel n1)
    /*this.buffer = localStorage.getItem('currentUser');
    this.currentUser = JSON.parse(this.buffer);
    this.nivelSelect = this.currentUser.idSprNivel*/
  }


  ngOnInit(): void {
    this.store.select("globalApp").subscribe((response) => {// redux
      this.planAnioSeleccionadoRedux = response.planAniosSeleccionado;
      this.nivelSelect = response.ambienteSeleccionado.nivel.idSprNivel;
      this.idSprAmbiente = response.ambienteSeleccionado.idSprAmbiente;
      this.idSprAnio = response.planAniosSeleccionado.idSprAnio;
      //this.initApp();
    });
  }




  openObjetivos() {
    this.nameLineaAccion = 'nav-objetivos'
    this.objetivo = 'objetivo'
  }
  openLineasAccion() {

    this.lineaAccion = 'lineas-accion'
  }

  openPlanesAccion() {

    this.planAccion = 'planes-accion'
  }
  openProyectos() {
    this.proyecto = 'proyecto';
  }
  openProcesos() {
    this.proceso = 'proceso';
  }


}
